import * as React from "react";
import {VeBoxModal} from "../../../../../components/modal/VeBoxModal";
import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";
import "./styles.scss";
import {Display} from "../../../../../components/Display";

declare var AppTranslations: AppTranslations;

interface AdviseModalProps {
    onClose: () => void;
    onSubmit?: () => void;
    onXClick?: () => void;
    title?: string;
    description?: JSX.Element;
    cancelText?: string;
    submitText?: string;
}

export const AdviseModal: React.FC<AdviseModalProps> = ({
                                                            onClose,
                                                            onSubmit,
                                                            description,
                                                            title,
                                                            cancelText,
                                                            onXClick,
                                                            submitText
                                                        }) => {
    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal>
                <VeBoxModal.Header
                    titleClassName={"advise-modal-header-title"}
                    title={
                        <h2 className={"advise-modal-header"}>
                            <span className="material-icons-outlined">info</span>
                            {title ? title : AppTranslations.genericWords.areYouSure}
                        </h2>
                    }
                    onClose={onXClick}
                />
                <VeBoxModal.Section>
                    <div className={"advise-modal-body"}>
                        {description ? (
                            description
                        ) : (
                            <>
                                <p>{AppTranslations.genericWords.areYouSureToProceed}</p>
                                <br></br>
                                <p>
                                    {AppTranslations.genericWords.theOperationMayTakesMinutes}
                                </p>
                            </>
                        )}
                    </div>
                </VeBoxModal.Section>
                <Display isVisible={onSubmit}>
                    <VeBoxModal.StandardActions
                        onCancel={onClose}
                        onSubmit={onSubmit}
                        submitText={submitText}
                        cancelText={cancelText}
                    />
                </Display>
                <Display isVisible={!onSubmit}>
                    <VeBoxModal.InfoAction onCancel={onClose} cancelText={cancelText}/>
                </Display>
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    );
};
